export default "__VITE_ASSET__5d73099f__"